import { computed, defineComponent, PropType } from "vue";

export interface ArticleFigure {
    image: string;
    title?: string;
    subtitle?: string;

    hero?: string;
}

export default defineComponent({
    template: `
        <div class="ArticleLayout">
            <div v-if="figure" class="ArticleLayout__figure" :style="styles">
                <div class="wrapper wrapper--1240">
                    <div class="ArticleLayout__figure-hero" :style="styles_hero">
                        <div class="ArticleLayout__figure-titles">
                            <div v-if="figure.title" class="ArticleLayout__figure-title">{{ figure.title }}</div>
                            <div v-if="figure.subtitle" class="ArticleLayout__figure-subtitle">{{ figure.subtitle }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ArticleLayout__wrapper" :class="{ 'wrapper': wrapper, ['wrapper--' + wrapper]: wrapper }">
                <div class="ArticleLayout__body">
                    <slot></slot>
                </div>
            </div>
        </div>
    `,

    props: {
        wrapper: { type: Number, default: 1320 },

        figure: { type: Object as PropType<ArticleFigure> },
    },

    setup(props, ctx) {
        const styles = computed(() => {
            const styles = {};

            if (props.figure.image) {
                styles['background-image'] = `url('${props.figure.image}')`;
            }

            return styles;
        });

        const styles_hero = computed(() => {
            const styles = {};

            if (props.figure.hero) {
                styles['background-image'] = `url('${props.figure.hero}')`;
            }

            return styles;
        });

        return {
            styles,
            styles_hero,
        };
    },
});
